// Service Worker Registration - Enhanced Auto-Update with Auto-Reload
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// Flag to prevent multiple reloads
let isReloading = false;

export function register(config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/service-worker.js';
      
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
      } else {
        registerValidSW(swUrl, config);
      }
    });
    
    // AUTO-RELOAD: When new service worker takes control, reload the page
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (isReloading) return;
      isReloading = true;
      
      console.log('[PWA] New version activated! Auto-reloading...');
      
      // Small delay to ensure SW is fully ready
      setTimeout(() => {
        window.location.reload();
      }, 500);
    });
    
    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'SW_UPDATED') {
        console.log('[PWA] Service worker updated to v' + event.data.version);
        
        // If page hasn't reloaded yet via controllerchange, reload now
        if (!isReloading) {
          isReloading = true;
          console.log('[PWA] Auto-reloading to apply updates...');
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
        
        if (config?.onUpdate) {
          config.onUpdate(null);
        }
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[PWA] Service Worker registered');
      
      // Check for updates immediately
      registration.update();
      
      // Check for updates every 60 seconds
      setInterval(() => {
        registration.update();
        console.log('[PWA] Checking for updates...');
      }, 60000);
      
      // Handle update found
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;
        
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New update available
              console.log('[PWA] New version available!');
              
              // Auto skip waiting
              if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
              }
              
              if (config?.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // First install - content cached
              console.log('[PWA] Content cached for offline use');
              if (config?.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
      
      // If there's already a waiting worker, activate it
      if (registration.waiting) {
        console.log('[PWA] Found waiting worker, activating...');
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    })
    .catch((error) => {
      console.error('[PWA] Registration error:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType && !contentType.includes('javascript'))) {
        // No service worker found
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('[PWA] No internet connection. App running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[PWA] Unregister error:', error);
      });
  }
}

// Force update - call this to force refresh the app
export function forceUpdate() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.update().then(() => {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        // Clear caches and reload
        if ('caches' in window) {
          caches.keys().then((names) => {
            names.forEach((name) => caches.delete(name));
          });
        }
        window.location.reload(true);
      });
    });
  } else {
    window.location.reload(true);
  }
}

// Clear all caches
export function clearCache() {
  if ('caches' in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        console.log('[PWA] Clearing cache:', name);
        caches.delete(name);
      });
    });
  }
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'CLEAR_CACHE' });
  }
}
